import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { SectionTab } from "polotno/side-panel";
import HiOutlinePhotograph from '@meronex/icons/hi/HiOutlinePhotograph';
import { getImageSize } from "polotno/utils/image";
import { ImagesGrid } from "polotno/side-panel/images-grid";
import axios from "axios";
import { BUCKETS, memesUploadURL } from "../constants";
import { InputGroup } from '@blueprintjs/core';

const GCPGraphicsTab = {
  name: "eCommerce Templates",
  Tab: (props) => (
    <SectionTab name="eCommerce Templates" {...props}>
      <HiOutlinePhotograph />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);
    const [loadedImages, setLoadedImages] = useState([])
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true)
    const [searchTxt, setSearchTxt] = useState()
    const [filteredImages, setFilteredImages] = useState([])

    async function loadImages() {
      // here we should implement your own API requests
      try {
        const response = await axios.get(`${memesUploadURL}/api/upload/${BUCKETS.GRAPHICSEMPIRE}`);
        // for demo images are hard coded
        // in real app here will be something like JSON structure
        setImages(
          response ?
            response.data
              ? response.data.data
                ? response.data.data
                : []
              : []
            : []
        );
        if (response?.data?.data) {
          setImages(response.data.data)
          setLoadedImages(response.data.data.slice(0, 20))
        }
        setLoading(false)
      } catch (err) {
        console.log(err);
      }
    }
    useEffect(() => {
      loadImages();
    }, []);

    const loadMore = () => {
      if (filteredImages.length === loadedImages.length || images.length === loadedImages.length) {
        return false
      }
      setLoading(true)
      setTimeout(() => {
        setPage(page + 1)
        searchTxt ? setLoadedImages(filteredImages.slice(0, page * 15)) : setLoadedImages(images.slice(0, page * 15))
        setLoading(false)
      }, 1000)
    }

    const searchImages = (value) => {
      setPage(1);
      setSearchTxt(value)
      if (value) {
        const fi = images.filter(image => image.name.toLowerCase().includes(value))
        console.log(fi);
        setFilteredImages(fi)
        setLoadedImages(fi.slice(0, 20))
      } else {
        setFilteredImages([])
        setLoadedImages(images.slice(0, 20))
      }
    }

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* you can create yur own custom component here */}
        {/* but we will use built-in grid component */}
        <InputGroup
          leftIcon="search"
          placeholder="Search..."
          onChange={(e) => {
            searchImages(e.target.value);
          }}
          style={{
            marginBottom: '20px',
          }}
        />
        <ImagesGrid
          images={loadedImages}
          getPreview={(image) => image.url}
          onSelect={async (image) => {
            const { width, height } = await getImageSize(image.url);
            store.activePage.addElement({
              type: "image",
              src: image.url,
              width,
              height,
              x: 50,
              y: 50,
            });
          }}
          rowsNumber={2}
          isLoading={loading}
          loadMore={() => {
            loadMore()
          }
          }
          getCredit={(image) => <span>{image.name}</span>}
        />
      </div>
    );
  }),
};

export default GCPGraphicsTab;
